export const init = async () => {
  if (process.env.NODE_ENV !== 'development') return

  const { worker } = await import('@tests/utils/mocks/browser')

  return worker.start({ onUnhandledRequest: 'bypass' })
}
